import { checkPropTypes, number } from 'prop-types';

var max = function max(value, proptypes) {
  if (proptypes === void 0) {
    proptypes = number;
  }

  return function (props, propName, componentName) {
    var _checkPropTypes;

    var valueProp = props[propName];
    checkPropTypes((_checkPropTypes = {}, _checkPropTypes[propName] = proptypes, _checkPropTypes), props, 'prop', componentName);

    if (valueProp > value) {
      return new Error("Invalid prop " + propName + " supplied to " + componentName + ". " + propName + " must be a value with maximum of " + value);
    }

    return null;
  };
};

export default max;